export default __webpack_public_path__ + "static/media/smile.82a951ea.svg";